import { z } from 'zod';

/////////////////////////////////////////
// FIELD DEFINITIONS SCHEMA
/////////////////////////////////////////

export const FieldDefinitionsSchema = z.object({
  fieldId: z.number().int(),
  cityId: z.number().int(),
  defaultSet: z.number().int(),
  searchable: z.number().int(),
  sortable: z.number().int(),
  displayable: z.number().int(),
  objectType: z.number().int(),
  objectName: z.string(),
  SQLName: z.string(),
  description: z.string(),
  label: z.string(),
  searchOperators: z.string(),
  pickList: z.string(),
  multiSelectPickList: z.number().int(),
  doTotal: z.number().int(),
  displayOrder: z.number().int(),
  displayGroup: z.string(),
  rowTimestamp: z.coerce.date(),
})

export type FieldDefinitions = z.infer<typeof FieldDefinitionsSchema>

export default FieldDefinitionsSchema;
